import React, { FC } from 'react'
import cx from 'classnames'
import { DivProps } from '@commonTypes'
import css from './dashboard.module.scss'

interface FooterCardInputs {
  title: string
  value: number | string
  className?: string
}

export function SubCard({ title, value, className }: FooterCardInputs) {
  return (
    <div className={cx(css.wrapper, className)}>
      <div className={css.value_wrapper}>{value}</div>
      <div className={css.title_wrapper}>{title}</div>
    </div>
  )
}

export const SubCardsWrapper: FC<React.PropsWithChildren<DivProps>> = ({ className, ...props }) => {
  return <div className={cx(css.sub_cards_wrapper, className)} {...props} />
}
